import type { ModuleRoute } from '../types';
import { BlockListPage } from './BlockListPage';
import { ComplianceReportPage } from './ComplianceReportPage';
import { ComplianceTypesPage } from './ComplianceTypesPage';
import { InductionsPage } from './InductionsPage';
import { NfcCardsPage } from './NfcCardsPage';

/** Pages of this area (block list, compliance documents and types, inductions, NFC cards). Owned by Phase 3 task W18; only that task edits files in this folder (W23 wires it last). */
export const routes: ModuleRoute[] = [
  {
    path: '/manage/safety-check',
    element: <BlockListPage />,
    permission: 'safety_check.view',
  },
  {
    path: '/manage/compliance',
    element: <ComplianceTypesPage />,
    permission: 'compliance.view',
  },
  {
    path: '/manage/compliance/report',
    element: <ComplianceReportPage />,
    permission: 'compliance.view',
  },
  {
    path: '/manage/inductions',
    element: <InductionsPage />,
    permission: 'inductions.view',
  },
  {
    path: '/manage/nfc-cards',
    element: <NfcCardsPage />,
    permission: 'nfc_cards.view',
  },
];
